<template>
    <v-container fluid>
        <v-btn
            @click="openDialog"
            :background-color="$store.getters.getColorPalette().background1ColorCode"
            :color="$store.getters.getColorPalette().btnborderColorCode"
            :dark="$store.getters.getColorPalette().isDark"
            outlined
            small
            text
        >
          {{$store.getters.getTextMap().update_profile}}<v-icon right :isDark="$store.getters.getColorPalette().isDark" :color="$store.getters.getColorPalette().deletebtnColor">mdi-pencil</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" max-width="1000">
          <v-card :dark="$store.getters.getColorPalette().isDark">
              <UpdateRootUserProfile :user="user" :userType="userType" v-on:close="onClose" />
          </v-card>
          
        </v-dialog>
         
    </v-container>
</template>

<script>
import UpdateRootUserProfile from '@/components/account_components/UpdateRootUserProfile'
  export default {
      name:'UpdateRootUserProfileBottomSheet',
      props:['user','userType'],
      components:{
          UpdateRootUserProfile
      },
    data () {
      return {
        dialog: false
      }
    },
    methods:{
        openDialog(){
            if(this.user && this.userType){
                this.dialog=!this.dialog
            }
        },
        onClose(){
            this.dialog=false
            this.$emit('close')
            }
        }

    }
</script>
<style scoped>
.uam{
  border:3px solid;
  border-radius:20px;
}
</style>
